import { Controller } from 'stimulus';
import axios from 'axios';
import Choices from 'choices.js';

export default class extends Controller {
  static targets = ['occupationCategorySelect', 'occupationSelect'];

  connect() {
    const choicesOptions = {
      shouldSort: false,
      itemSelectText: '',
      searchResultLimit: 50,
    };
    this.categoryChoices = new Choices(this.occupationCategorySelectTarget, choicesOptions);
    this.occupationChoices = new Choices(this.occupationSelectTarget, choicesOptions);
  }

  occupationCategoryChange(e) {
    axios
      .get(this.data.get('occupations-url'), {
        params: { occupation_category_id: e.target.value },
      })
      .then(res => {
        const items = [];
        res.data.forEach(occupation => {
          items.push({ value: String(occupation.id), label: occupation.text });
        });
        this.occupationChoices.clearStore();
        items[0].selected = true;
        this.occupationChoices.setChoices(items, 'value', 'label', true);
      });
  }
}
